export default __webpack_public_path__ + "static/media/biomarker-img.cfa2d4b8.svg";